import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomInput from "../components/CustomInput";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../features/auth/authSlice";

//Yup schema
let schema = yup.object({
  email: yup.string().email().required("Email is required"),
  password: yup.string().required("Password is required"),
});

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: schema,

    onSubmit: (values) => {
      dispatch(login(values));
    },
  });
  const authState = useSelector((state) => state.auth);
  const { user, isLoading, isError, isSuccess, message } = authState;

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (userData?.token) {
      navigate("/admin");
    }
  }, [navigate]);

  useEffect(() => {
    if (isSuccess && user) {
      if (user?.user?.role === 'admin') {
        navigate("/admin");
      } else {
        alert("Not authorized as admin");
      }
    }
    if (isError) {
      alert(message || "Login failed");
    }
  }, [user, isLoading, isError, isSuccess, message, navigate]);

  return (
    <div className="py-5" style={{ background: "#ffd333", minHeight: "100vh" }}>
      <div className="my-5 w-25 bg-white rounded-3 mx-auto p-3">
        <h3 className="text-center">Login</h3>
        <p className="text-center">Login to your account to continue</p>

        <div className="error text-danger text-center">
          {isError ? <div>{message.message}</div> : null}
        </div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="email"
            id="email"
            label="Email"
            val={formik.values.email}
            onCh={formik.handleChange("email")}
            onBl={formik.handleBlur("email")}
          />

          <div className="error mb-3">
            {formik.touched.email && formik.errors.email ? (
              <div className="text-danger">{formik.errors.email}</div>
            ) : null}
          </div>

          <CustomInput
            type="password"
            name="password"
            id="pass"
            label="Password"
            val={formik.values.password}
            onCh={formik.handleChange("password")}
            onBl={formik.handleBlur("password")}
          />
          <div className="error mb-3">
            {formik.touched.password && formik.errors.password ? (
              <div className="text-danger ">{formik.errors.password}</div>
            ) : null}
          </div>

          <button
            className="btn border-0 px-3 py-2 w-100 rounded-3"
            style={{ background: "#ffd333" }}
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
